<template>
    <div class="row panel-body">
        <form method="post" ref="form">
            <input type="hidden" name="_token" :value="csrfToken"/>

            <quiz-creation-question
                    v-for="(question, idx) in questions"
                    v-on:delete="removeQuestion(idx)"
                    v-on:forceUpdate="forceUpdate()"
                    v-on:copyQuestion="copyQuestion"
                    ref="questions"
                    :idx="idx"
                    :key="question.qid"
                    :iqid="question.qid"
                    :itype="question.type"
                    :ilevel="parseInt(question.level)"
                    :iXX_en="question.text.XX_en"
                    :ioptions="question.options"
                    :isuggestedAnswerOid="question.suggestedAnswerOid"
                    :ipictureUrl="question.pictureUrl"
                    :disabled="isDisabled(question.qid)"
                    :wasRejected="rejected.length > 0"
                    :image-upload-route="imageUploadRoute"
                    :question-types-json="questionTypesJson"
            ></quiz-creation-question>

            <button
                    class="btn btn-success"
                    style="width: 100%; margin: 50px 0;"
                    type="button"
                    v-if="rejected.length === 0"
                    @click="addQuestion">
                <i class="fa fa-plus"></i>
                Add Question
            </button>

            <div class="row">
              <div class="col-xs-6 text-right">
                <label class="m-t-sm m-b-lg">
                  Does this quiz require localization?
                </label>
              </div>

              <div class="col-xs-6">
                <div class="input-group m-t-sm m-b-lg">
                  <div>
                    <label>
                      <input
                        v-model="quizRequiresLocalization"
                        type="radio"
                        name="isQuizLocalizationRequired"
                        id="is_quiz_localization_required_yes"
                        v-bind:value="true"
                      />
                      Yes
                    </label>
                    <label class="m-l-xs">
                      <input
                        v-model="quizRequiresLocalization"
                        type="radio"
                        name="isQuizLocalizationRequired"
                        id="is_quiz_localization_required_no"
                        v-bind:value="false"
                      />
                      No
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
                <div class="col-xs-6">
                    <button class="btn btn-default"
                            name="submit-save"
                            @click.prevent="save('Saved')">
                        <strong>Save</strong>
                    </button>
                </div>

                <div class="col-xs-6 text-right">
                    <submit-button  :disabled="!allDataIsValid"
                                    :title="allDataIsValid
                                      ? 'Submit'
                                      : 'You must enter at least ' + this.minQuestionsPerLevel + ' valid questions for each level.'"
                    ></submit-button>
                </div>
            </div>
            <input type="hidden" name="rejectionComment" :value="rejectionComment"/>
            <input type="hidden"
                   v-for="qid in this.rejected"
                   name="rejected[]"
                   :value="qid"
            />
        </form>
    </div>
</template>

<script>
    let toastr = require('toastr');

    export default {
        props: {
            'questionsJson': String,
            'requiresLocalization': Boolean,
            'rejectedJson': String,
            'rejectionComment': String,
            'questionTypesJson': String,
            'saveRoute': String,
            'imageUploadRoute': String,
            'minimumQuestionsPerLevel': String,
        },

        data: function() {
            return {
                questions: JSON.parse(this.questionsJson),
                quizRequiresLocalization: this.requiresLocalization ? 'true' : 'false',
                csrfToken: window.csrfToken,
                updateTrigger: false,
                minQuestionsPerLevel: parseInt(this.minimumQuestionsPerLevel),
                autosaveCache: '',
            };
        },

        computed: {
            rejected: function() {
                return JSON.parse(this.rejectedJson);
            },

            allDataIsValid: function() {
                if (this.updateTrigger) {
                  if (
                      this.getQuestionCount(1) < this.minQuestionsPerLevel
                      || this.getQuestionCount(2) < this.minQuestionsPerLevel
                      || this.getQuestionCount(3) < this.minQuestionsPerLevel
                  ) {
                      return false
                    }

                    let valid = true;
                    for (let index in this.$refs.questions) {
                        valid = this.$refs.questions[index].validate() && valid;
                    }

                    return valid;
                }
            },
        },

        mounted() {
            this.autosaveCache = $(this.$refs.form).serialize();
            this.autosaveTimer();

            this.updateTrigger = true;
            this.forceUpdate();
        },

        methods: {
            updateQuestionCount: function() {
              $('#questionCountEasy').html(this.getQuestionCount(1));
              $('#questionCountEasyRow').removeClass(this.getQuestionCount(1) >= this.minQuestionsPerLevel ? 'alert-danger' : 'alert-success');
              $('#questionCountEasyRow').addClass(this.getQuestionCount(1) < this.minQuestionsPerLevel ? 'alert-danger' : 'alert-success');
              $('#questionCountMedium').html(this.getQuestionCount(2));
              $('#questionCountMediumRow').removeClass(this.getQuestionCount(2) >= this.minQuestionsPerLevel ? 'alert-danger' : 'alert-success');
              $('#questionCountMediumRow').addClass(this.getQuestionCount(2) < this.minQuestionsPerLevel ? 'alert-danger' : 'alert-success');
              $('#questionCountHard').html(this.getQuestionCount(3));
              $('#questionCountHardRow').removeClass(this.getQuestionCount(3) >= this.minQuestionsPerLevel ? 'alert-danger' : 'alert-success');
              $('#questionCountHardRow').addClass(this.getQuestionCount(3) < this.minQuestionsPerLevel ? 'alert-danger' : 'alert-success');
            },

            getQuestionCount: function(level) {
                let count = 0;
                for (let index in this.$refs.questions) {
                  let question = this.$refs.questions[index];
                  if (('level' in question) && (parseInt(question.level) === parseInt(level))) {
                    count++;
                  }
                }
                return count;
            },

            forceUpdate: function() {
                this.updateTrigger = false;
                this.$forceUpdate();
                this.updateTrigger = true;
                this.updateQuestionCount();
            },

            getIsCorrect() {
                return this.isCorrect;
            },

            generateUuid() {
                return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
                    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16),
                );
            },

            getHighestLevel() {
                let highestLevel = 1;
                for (let index in this.$refs.questions) {
                    let question = this.$refs.questions[index];
                    highestLevel = Math.max(question.level, highestLevel);
                }
                return parseInt(highestLevel);
            },

            copyQuestion: function(qid) {
                let question = null;
                for (let index in this.$refs.questions) {
                    if (('qid' in this.$refs.questions[index]) && this.$refs.questions[index].qid === qid) {
                        question = this.$refs.questions[index];
                        break;
                    }
                }

                if (question === null) {
                    return;
                }

                let options = [];
                let suggestedAnswerOid = null;
                for (let _index in question.$refs.options) {
                    let option = question.$refs.options[_index];
                    let oid = this.generateUuid();
                    if (question.suggestedAnswerOid === option.oid) {
                        suggestedAnswerOid = oid;
                    }
                    options.push({
                        'isCorrect': option.isCorrect,
                        'text': {
                            'XX_en': option.XX_en,
                        },
                        'oid': oid,
                    });
                }

                this.questions.push({
                    'qid': this.generateUuid(),
                    'type': question.type,
                    'level': parseInt(question.level),
                    'text': {
                        'XX_en': question.XX_en,
                    },
                    'pictureUrl': question.pictureUrl,
                    'options': options,
                    'suggestedAnswerOid': suggestedAnswerOid,
                });

                this.forceUpdate();
            },

            addQuestion: function() {
                this.questions.push({
                    'qid': this.generateUuid(),
                    'type': null,
                    'level': this.getHighestLevel(),
                    'text': {
                        'XX_en': '',
                    },
                    'pictureUrl': '',
                    'options': [],
                    'suggestedAnswerOid': null,
                });
                this.forceUpdate();
            },

            removeQuestion: function(idx) {
                this.$refs.questions.splice(idx, 1);
                this.questions.splice(idx, 1);
                this.forceUpdate();
            },

            isDisabled(qid) {
                if (this.rejected.length === 0) {
                    return false;
                }

                return this.rejected.indexOf(qid) === -1;
            },

            autosaveTimer() {
                setTimeout(() => {
                    this.autosave();
                    this.autosaveTimer();
                }, 60000); // once per minute
            },

            autosave() {
                // only autosave if form data has changed since last save
                if (this.autosaveCache !== $(this.$refs.form).serialize()) {
                    this.save('Auto saved');
                }
            },

            save(message) {
                let formData = $(this.$refs.form).serialize();
                window.axios.post(this.saveRoute, formData).then(() => {
                    this.autosaveCache = formData;
                    toastr.success(message);
                }).catch(() => {
                    toastr.error('Something went wrong...', message);
                });
            },
        },
    };
</script>
